import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { KeyValue } from "@models/generic/KeyValuePair";
import { DevManagementDataService } from "@app/admin/services/devmanagement.service";

@Component({
    selector: "dev-export",
    templateUrl: "./dev-export.component.html",
    styleUrls: ["./dev-export.component.scss"],
    imports: [FormsModule, NgSelectModule]
})
export class DevExportComponent {
    private dataService = inject(DevManagementDataService);

    exportTypes: KeyValue<number, string>[];
    selectedExportType: number;

    constructor() {
        this.dataService.getExportTypes().subscribe((x) => {
            this.exportTypes = x;
            this.selectedExportType = x[0].Key;
        });
    }

    public export() {
        this.dataService.export(this.selectedExportType);
    }
}
